<template>
  <div class="bid-records-page">
        <van-nav-bar 
      title="竞价记录" 
      left-text="返回" 
      left-arrow 
      fixed 
      :placeholder="true" 
      @click-left="goBack"
    />
    <div class="content">
      <van-pull-refresh v-model="refresh" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          :immediate-check="false"
          :finished-text="tableData.length ? '没有更多了' : ''"
          @load="onLoad"
        >
          <van-skeleton v-if="loading && tableData.length === 0" class="product-skeleton" title :row="5" />
          <div v-for="(item, index) in tableData" :key="item.order_id || index" class="order-card-outer">
            <div class="order-card-strict">
              <!-- 上部分 -->
              <div class="order-card-top">
                <div class="top-left">
                  <div class="cinema-name">{{ item.cinema_name }}</div>
                  <div class="order-row">
                    <span class="order-id">{{ item.order_id }}</span>
                    <span class="copy-btn" @click="copyOrderNo(item.order_id)">复制</span>
                  </div>
                </div>
                <div class="top-right">
                  <div class="market-price">
                    <span>市场价:</span><span class="market-price-num">￥{{ item.channel_price }}</span>
                  </div>
                  <div class="status-info">
                    <span class="status-text" :class="getStatusClass(item.status_text)">{{ item.status_text }}</span>
                    <van-count-down
                      v-if="canModifyBid(item)"
                      class="record-countdown"
                      :time="Number(item.remaining) * 1000"
                      format="mm:ss"
                      @finish="handleCountdownFinish(item)"
                    />
                  </div>
                </div>
              </div>
              <!-- 分割线 -->
              <div class="order-card-divider"></div>
              <!-- 下部分：影片信息 + 城市 -->
              <div class="order-card-bottom">
                <div class="bottom-left">
                  <div class="movie-img-box">
                    <van-image width="80px" height="100%" fit="cover" :src="item.logo+'_200x200'" />
                  </div>
                  <div class="movie-info-box">
                    <div class="movie-title-row">
                      <div class="movie-title">{{ item.movie_name }}</div>
                      <div class="city-name">{{ item.city_name }}</div>
                    </div>
                    <div class="movie-tags">
                      <span class="ticket-count">{{ item.quantity }}张</span>
                      <span v-if="item.support_exchange_seat == 'Y'" class="seat-type-tag">九宫格换座</span>
                      <span v-if="item.seat_tag" class="seat-type-tag">{{ item.seat_tag }}</span>
                    </div>
                    <div class="showtime-row">
                      <span class="today-tag" v-if="item.play_date_tag">{{ item.play_date_tag }}</span>
                      <span class="showtime">{{ item.play_time_text }}</span>
                    </div>
                    <div class="hall-name" v-if="item.hall_name">{{ item.hall_name }}</div>
                  </div>
                </div>
              </div>
              <!-- 底部一行：中单价靠左，我的报价靠右 -->
              <div class="order-card-price-row">
                <span v-if="!isBidding(item) && item.bid_price > 0" class="win-price">
                  <span>中单价:</span>
                  <span class="price-num win">￥{{ item.bid_price }}</span>
                </span>
                <span class="my-bid-price">
                  <span>我的报价:</span>
                  <span class="price-num">￥{{ item.my_bid_price }}</span>
                </span>
                <van-button
                  v-if="canModifyBid(item)"
                  size="small"
                  type="danger"
                  class="edit-bid-btn"
                  @click="editBid(item)"
                >
                  修改报价
                </van-button>
              </div>
            </div>
          </div>
          <van-empty
            v-if="finished && !loading && tableData.length === 0"
            class="product-empty"
            image="search"
            :description="loadError ? '加载失败，请检查网络后重试' : '暂无竞价记录'"
          >
            <van-button v-if="loadError" size="small" plain type="primary" @click="retryLoad">重新加载</van-button>
          </van-empty>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import Api from '@/api-service'
import { Toast } from 'vant'

export default {
  name: 'BidRecords',
  data() {
    return {
      tableData: [],
      loading: false,
      loadError: false,
      finished: false,
      refresh: false,
      queryData: {
        page: 1,
        pageSize: 10
      }
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    // 下拉刷新请求
    onRefresh() {
      this.queryData.page = 1
      this.tableData = []
      this.finished = false
      this.fetchData()
    },
    // 上拉加载更多请求
    onLoad() {
      if (this.loading || this.finished) return
      this.queryData.page++
      this.fetchData()
    },
    // 获取数据
    fetchData() {
      this.loading = true
      this.loadError = false
      Api.bidRecord(this.queryData).then(res => {
        this.loading = false
        this.refresh = false
        
        if (res.list && res.list.length > 0) {
          this.tableData = [...this.tableData, ...res.list]
          if (res.list.length < this.queryData.pageSize) {
            this.finished = true
          }
        } else {
          this.finished = true
        }
      }).catch(err => {
        this.loading = false
        this.refresh = false
        this.loadError = true
        if (this.tableData.length === 0) this.finished = true
        console.error('获取竞价记录失败:', err)
      })
    },

    retryLoad() {
      this.queryData.page = 1
      this.tableData = []
      this.finished = false
      this.fetchData()
    },

    copyOrderNo(orderId) {
      if (!orderId) return
      if (navigator && navigator.clipboard) {
        navigator.clipboard.writeText(orderId).then(() => {
          Toast.success('复制成功')
        }).catch(() => {
          Toast.fail('复制失败')
        })
      } else {
        // 兼容旧浏览器
        const textArea = document.createElement('textarea')
        textArea.value = orderId
        document.body.appendChild(textArea)
        textArea.select()
        try {
          document.execCommand('copy')
          Toast.success('复制成功')
        } catch (err) {
          Toast.fail('复制失败')
        }
        document.body.removeChild(textArea)
      }
    },

    // 获取状态样式类
    getStatusClass(status) {
      switch(status) {
        case '上报成功':
          return 'status-success'
        case '竞价失败':
          return 'status-fail'
        case '竞价中':
          return 'status-bidding'
        case '等待竞价结果':
          return 'status-pending-result'
        case '取消报价':
          return 'status-cancel'
        case '超时转单':
          return 'status-timeout'
        case '已提现':
          return 'status-withdraw'
        case '超过限价':
          return 'status-overprice'
        case '中标，待确认':
          return 'status-bidded'
        case '确认，待上传':
          return 'status-confirm'
        case '已退款':
          return 'status-refund'
        default:
          return 'status-default'
      }
    },

    isBidding(item) {
      return Number(item && item.status) === 3
    },

    canModifyBid(item) {
      return Boolean(item && item.can_modify_bid) && Number(item.remaining) > 0
    },

    handleCountdownFinish(item) {
      this.$set(item, 'remaining', 0)
      this.$set(item, 'can_modify_bid', false)
      this.$set(item, 'status_text', '等待竞价结果')
    },

    editBid(item) {
      const orderData = {
        ...item,
        my_bid_price: item.my_bid_price
      }
      this.$router.push({
        name: 'BidOrderDetail',
        params: { orderId: item.order_id },
        query: {
          from: 'bid-records',
          order: encodeURIComponent(JSON.stringify(orderData))
        }
      })
    },

    // 返回上一页
    goBack() {
      this.$router.back()
    }
  }
}
</script>

<style lang="scss" scoped>
.bid-records-page {
  background: #f7f7fa;
  min-height: 100vh;

  .content {
    padding-top: 10px;
  }
}

.order-card-outer {
  margin: 12px;
}

.order-card-strict {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
  padding: 13px 12px;
  display: flex;
  flex-direction: column;
  font-family: inherit;
  min-height: 0;
}

.order-card-top {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 2px;
  flex-shrink: 0;
}

.top-left {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  min-width: 0;
}

.cinema-name {
  font-size: 16px;
  font-weight: bold;
  color: #222;
  line-height: 1.2;
  margin-bottom: 2px;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.order-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 4px;
}

.order-id {
  font-size: 12px;
  color: #888;
  font-family: monospace;
}

.copy-btn {
  font-size: 12px;
  color: #1890ff;
  cursor: pointer;
  padding: 2px 6px;
  border-radius: 4px;
  background-color: rgba(24, 144, 255, 0.1);
  transition: background-color 0.2s;

  &:active {
    background-color: rgba(24, 144, 255, 0.2);
  }
}

.top-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  flex-shrink: 0;
  min-width: 60px;
  margin-left: 8px;
}

.market-price {
  font-size: 13px;
  margin-bottom: 2px;
  color: #888;
}

.market-price-num {
  color: #ff2c54;
  font-weight: bold;
  margin-left: 2px;
}

.status-info {
  margin-top: 4px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 4px;
}

   .status-text {
    font-size: 12px;
    font-weight: bold;
    padding: 2px 6px;
    border-radius: 4px;
    
    &.status-success {
      background-color: #f6ffed;
      color: #52c41a;
    }
    
    &.status-fail {
      background-color: #fff2f0;
      color: #ff4d4f;
    }
    
    &.status-bidding {
      background-color: #e6f7ff;
      color: #1890ff;
    }

    &.status-pending-result {
      background-color: #fff7e6;
      color: #d97917;
    }
    
    &.status-cancel {
      background-color: #f5f5f5;
      color: #999;
    }
    
    &.status-timeout {
      background-color: #fff7e6;
      color: #fa8c16;
    }
    
    &.status-withdraw {
      background-color: #f0f5ff;
      color: #722ed1;
    }
    
    &.status-overprice {
      background-color: #fff1f0;
      color: #cf1322;
    }
    
    &.status-bidded {
      background-color: #f6ffed;
      color: #389e0d;
    }
    
    &.status-confirm {
      background-color: #e6fffb;
      color: #08979c;
    }
    
    &.status-refund {
      background-color: #fff2e8;
      color: #d46b08;
    }
    
    &.status-default {
      background-color: #f5f5f5;
      color: #666;
    }
  }

  .record-countdown {
    color: #e5484d;
    font-size: 12px;
    font-weight: 600;
  }

.order-card-bottom {
  min-height: 100px;
  margin-top: 4px;
}

.bottom-left {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
}

.movie-img-box {
  flex-shrink: 0;
  margin-right: 12px;
  height: 100px;
  display: flex;
}

.movie-img-box .van-image {
  width: 80px !important;
  height: 100px !important;
}

.movie-info-box {
  flex: 1;
  min-width: 0;
}

.movie-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 6px;
}

.movie-title-row .movie-title {
  flex: 1;
  min-width: 0;
  font-size: 15px;
  font-weight: 500;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.movie-title-row .city-name {
  flex-shrink: 0;
  font-size: 13px;
  font-weight: bold;
  color: #333;
  margin: 0;
}

.movie-tags {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
  gap: 6px;
}

.ticket-count {
  background: #f7f8fa;
  border-radius: 8px;
  font-size: 10px;
  padding: 1px 1px;
}

.seat-type-tag {
  border: 2px solid rgb(0, 140, 255);
  color: rgb(0, 140, 255);
  border-radius: 2px;
  font-size: 10px;
  font-weight: bold;
  padding: 2px 2px;
}

.showtime-row {
  font-size: 13px;
  color: #333;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 6px;
}

 .hall-name {
   font-size: 13px;
   color: #888;
   margin-bottom: 2px;
   line-height: 1.2;
   max-width: 100%;
   overflow: hidden;
   text-overflow: ellipsis;
   white-space: nowrap;
 }


.today-tag {
  display: inline-block;
  color: white;
  background-color: #ff2c53da;
  font-size: 12px;
  font-weight: bold;
  padding: 2px 6px 2px 4px;
  margin-right: 2px;
  line-height: 1.2;
  vertical-align: middle;
  border-radius: 2px;
  clip-path: polygon(
    0 0,
    calc(100% - 8px) 0,
    100% 50%,
    calc(100% - 8px) 100%,
    0 100%
  );
}

.showtime {
  color: #333;
}

/* 底部一行：中单价靠左，我的报价靠右 */
.order-card-price-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #f0f0f0;
}

.order-card-price-row .win-price {
  font-size: 13px;
  color: #666;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
}

.order-card-price-row .my-bid-price {
  font-size: 13px;
  color: #666;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
  margin-left: auto;
}

.order-card-price-row .price-num {
  font-weight: bold;
  color: #ff2c54;
}

.order-card-price-row .price-num.win {
  color: #52c41a;
}

.order-card-price-row .edit-bid-btn {
  flex-shrink: 0;
  min-width: 82px;
  height: 34px;
  margin-left: 4px;
  border-radius: 8px;
}



.order-card-divider {
  height: 1px;
  background: #eee;
  margin: 2px 0 8px 0;
  width: 100%;
}

@media (max-width: 359px) {
  .order-card-strict {
    padding: 12px 10px;
  }

  .movie-img-box,
  .movie-img-box .van-image {
    width: 68px !important;
  }

  .movie-img-box {
    margin-right: 9px;
  }
}
</style>
